import { useContext, useEffect, useMemo } from "react";
import { FeatureCollection } from "geojson";
import { MapContext } from "../context/map.context";
//@ts-ignore
import Mazemap from "@itpi/mazemap";
import { MapPin } from "../components/Map";

type FocusPointsOptions = {
  pins?: boolean;
};

export const useFocusOnPoints = (points: MapPin[], padding = 100) => {
  const { fitBounds, setPins, reset } = useContext(MapContext);

  const featureCollection = useMemo((): FeatureCollection | undefined => {
    if (points.length > 0) {
      return {
        type: "FeatureCollection",
        features: points.map((p) => ({
          type: "Feature",
          properties: {},
          geometry: {
            type: "Point",
            coordinates: [p.lng!, p.lat!],
          },
        })),
      };
    }
  }, [points]);

  useEffect(() => {
    if (featureCollection) {
      const bounds = Mazemap.Util.Turf.bbox(featureCollection);
      fitBounds(bounds, { padding: 100 });
      setPins(points.map((p) => ({ ...p })));
      return reset;
    }
  }, [featureCollection, points, fitBounds, reset, setPins]);
};
